import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssessmentInfoModule } from './assessment-info/assessment-info.module';
import { AssignRecruiterModule } from './assign-recruiter/assign-recruiter.module';
import { TooltipModule } from 'ngx-bootstrap';
import { CancelAssessmentModule } from './cancel-assessment/cancel-assessment.module';
import { ViewAssessmentReportModule } from './view-assessment-report/view-assessment-report.module';
import { ExportCandidateDocumentsModule } from './export-candidate-documents/export-candidate-documents.module';
import { SetJobMatchStatusModule } from './set-job-match-status/set-job-match-status.module';
import { MoveJobMatchStepModule } from './move-job-match-step/move-job-match-step.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AssessmentInfoModule,
    AssignRecruiterModule,
    CancelAssessmentModule,
    ViewAssessmentReportModule,
    ExportCandidateDocumentsModule,
    SetJobMatchStatusModule,
    MoveJobMatchStepModule
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class JobMatchActionsModule { }
